// extracted by mini-css-extract-plugin
var _1 = "styles-module__container___IQNq1";
var _2 = "styles-module__description___WRuTD";
var _3 = "styles-module__textContainer___WF_WA";
export { _1 as "container", _2 as "description", _3 as "textContainer" }
